// Author Lin
// Date 2021-11-20 09:59:43

class MintalMesPrdPelletizingProductTreatmentParameter {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                recordTime = '',
                materialFlowOne = '',
                materialFlowTwo = '',
                materialFlowThree = '',
                materialFlowFour = '',
                vibrationSieveStatusOne = '',
                vibrationSieveStatusTwo = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.recordTime = recordTime;
            this.materialFlowOne = materialFlowOne;
            this.materialFlowTwo = materialFlowTwo;
            this.materialFlowThree = materialFlowThree;
            this.materialFlowFour = materialFlowFour;
            this.vibrationSieveStatusOne = vibrationSieveStatusOne;
            this.vibrationSieveStatusTwo = vibrationSieveStatusTwo;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdPelletizingProductTreatmentParameter();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'materialFlowOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.materialFlowOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'materialFlowTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.materialFlowTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'materialFlowThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.materialFlowThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'materialFlowFour',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.materialFlowFour',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'vibrationSieveStatusOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.vibrationSieveStatusOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'vibrationSieveStatusTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.vibrationSieveStatusTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            materialFlowOneFilter : '',
            materialFlowTwoFilter : '',
            materialFlowThreeFilter : '',
            materialFlowFourFilter : '',
            vibrationSieveStatusOneFilter : '',
            vibrationSieveStatusTwoFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'materialFlowOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.materialFlowOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'materialFlowTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.materialFlowTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'materialFlowThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.materialFlowThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'materialFlowFour',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.materialFlowFour',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'vibrationSieveStatusOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.vibrationSieveStatusOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'vibrationSieveStatusTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.vibrationSieveStatusTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingProductTreatmentParameter.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdPelletizingProductTreatmentParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        